import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import { Modal } from 'react-bootstrap';

import wall1 from "../images/metamask_wallet.png";
import wall2 from "../images/connect_wallet.png";
import wall3 from "../images/wall3.png";

import { MetamaskWallet, WalletConnect } from "../hooks/useWallet"
import Web3 from 'web3';
import { Link } from 'react-router-dom';


class Createmodal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            createModal: true,

        };
    }




    render() {


        const { createModal } = this.state


        return (



            <Modal className="wallet-modal" show={createModal} centered size="md">
                <Modal.Header className='pt-3 header_odal_head'>
                    <h2 className="sec-head ">Create</h2>
                    <button type="button" class="close" onClick={() =>{this.props.onDismiss()}}><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>
                </Modal.Header>
                <Modal.Body className="select-wallet modal_body pt-0 pb-0 px-0">
                    <div className="wallet-lists px-2 wallet-lists-new-m">
                       {/* <div className='row px-5 justify-content-between'>
                         <div className='col-md-4'>
                         <button className='btn get-started-btn blackbtn w-100 mr-2'> Home </button>
                        </div>     
                        <div className='col-md-4'>
                         <button className='btn get-started-btn blackbtn w-100 mr-2'> Home </button>
                        </div>    
                       </div> */}
                       <div className='allflex px-4'>
                       <Link to="/create"><button className='btn get-started-btn blackbtn w-100 mr-2'> Create Launchpad </button></Link>
                       <Link to="/createfairlaunch"><button className='btn get-started-btn blackbtn w-100 mr-2'> Create Fair Launch </button></Link>
                       <Link to="/createtoken"><button className='btn get-started-btn blackbtn w-100 mr-2'> Token Creation </button></Link>
                       <Link to="/createprivatesale"><button className='btn get-started-btn blackbtn w-100 mr-2'> Create Private Sale </button></Link>
                       <Link to="/createlock"><button className='btn get-started-btn blackbtn w-100 mr-2'> Create Lock </button></Link>
                       <Link to="/createairdrop"><button className='btn get-started-btn blackbtn w-100 mr-2'> Create Airdrop </button></Link>
                       </div>
                    </div>
                </Modal.Body>
            </Modal>



        )
    }

}


export default Createmodal